<ng-container *ngIf="word">
  <div class="connect-head {{ btnClose ? '' : 'no-close' }}">

    <div class="head-box">

      <app-word-disp [word]="word"></app-word-disp>

      <app-popup-word-play-btn [word]="word"></app-popup-word-play-btn>

      <!-- app-word-record-btn [word]="word"></app-word-record-btn -->

    </div>

    <!-- div class="derivative"
         *ngIf="getDerivative(word)">→{{ getDerivative(word) }}</div -->

    <!-- div class="menu-box" *ngIf="btnClose">
      <a class="close-btn"
         (click)="onClose($event)"></a>
    </div -->

  </div>

  <div class="connect-body">

    <div class="layout-box">

      <!-- 나중에 품사 표시를 복구할 수 있으므로 삭제하지 말 것 (#371).
      <div class="key-box">
        <div class="key-txt" *ngFor="let poomsa of word.partOfSpeech">{{ GetPoomsaTxt(poomsa) }}</div>

      </div>
      -->

      <div class="item-box">

        <div class="item-list">
          <div class="word-item">
            <div class="item-txt"
                 *ngFor="let hun of word.hanjaHun">
              {{ hunBody(hun) }}
              <div class="char">{{ hunChar(hun) }}</div>
            </div>
          </div>
        </div>

      </div>

    </div>

    <div class="meaning-list">
      <ng-container *ngFor="let meaning of word.meaning.slice(0,3); let idx = index">
        <div class="meaning-box" *ngIf="word.GetMeaningNth(idx)">
          <div class="subject">{{(idx > 0 && !word.GetMeaningNth(0) || idx === 0) ? "뜻" : ""}}{{ idx > 0 ? idx : "" }}</div>
          <div class="con" [innerHTML]="meaning | resize | keepHtml"></div>
        </div>
      </ng-container>
    </div>

    <div class="more-btn-box"
         *ngIf="showMoreBtn">
      <a class="more-btn" (click)="onGotoDetail($event)">
        자세히 보기 {{ getMoreMeanings(word) > 0 ? '(' + getMoreMeanings(word) + '개의 뜻이 더 있습니다)' : ''}}
      </a>

    </div>
  </div>

</ng-container>
